import { SavePdbType } from "../shared/enums/SavePdbType";
import { useCartOptional } from "../store/hooks/useCartOptional";
import { useCartProduct } from "../store/hooks/useCartProduct";
import { useMachineTonnage } from "../store/hooks/useMachineTonnage";
import { useMarket } from "../store/hooks/useMarket";
import { useOptional } from "../store/hooks/useOptional";
import { useProduct } from "../store/hooks/useProduct";
import { useWizard } from "../store/hooks/useWizard";
import { StoreStateSummary } from "../store/interfaces/storeState";

export const useSummary = () => {
  const cartOptional = useCartOptional();
  const cartProduct = useCartProduct();
  const {
    machineFixingType: productMachineFixingType,
    productCategory,
    toolsProductTypes: productToolsProductTypes,
  } = useProduct();
  const {
    isMachineFixingsSelected,
    isTiltrotatorsSelected,
    isToolsSelected,
    machineFixingType: optionalMachineFixingType,
    toolsProductTypes: optionalToolsProductTypes,
  } = useOptional();
  const machineTonnage = useMachineTonnage();
  const market = useMarket();
  const wizard = useWizard();

  const getSummary = (): StoreStateSummary => {
    return {
      cart: {
        optional: cartOptional,
        product: cartProduct,
      },
      isLoadedFromSummary: true,
      optional: {
        isMachineFixingsSelected,
        isTiltrotatorsSelected,
        isToolsSelected,
        machineFixingType: optionalMachineFixingType,
        toolsProductTypes: optionalToolsProductTypes,
      },
      product: {
        machineFixingType: productMachineFixingType,
        productCategory,
        toolsProductTypes: productToolsProductTypes,
      },
      machineTonnage,
      market,
      type: SavePdbType.Summary,
      wizard,
    };
  };

  return {
    getSummary,
  };
};
